$(() => {
  $(document).on('click', '.js-dismiss', function (e) {
    e.preventDefault()
    $(this).parents('.js-dismiss-parent').remove()
    clearTimeout(window.flashTimeoutId)
  })
})
